module.exports = __webpack_public_path__ + "img/lk_empty_team.757c1d5b.svg";